import React from 'react';
import {Alert} from '@bonprix/design-system';

export default function CartNotDeliverableToPickUpLocationWarning({texts}) {
    return (
        <div className="cart__deliverability-hint-wrapper">
            <Alert isOpen severity='warning' showCloseIcon={false}>
                {texts.cot09_hint_delivery_to_pick_up_location_not_possible + ' ' + texts.cot09_hint_remove_not_deliverable_article_from_cart}
            </Alert>
        </div>
    );
}
